import type { CircuitBoardMarker } from "../CircuitPathsLayer/types";
import type { SourceConfidence } from "./types";

// Resolve a marker's placement confidence, falling back to the legacy
// `uncertain` flag when the agent hasn't supplied `confidence` yet.
export const resolveSourceConfidence = (
  marker: CircuitBoardMarker,
): SourceConfidence =>
  marker.confidence ?? (marker.uncertain ? "estimated" : "confident");
